import React from 'react';
import ImageWithBasePath from './imageWithBasePath';

interface Props {
    size?: 'L' | 'S'
    url?: string
    name?: string
}

const HeaderLogo: React.FC<Props> = ({ size = 'L', url = '', name = '' }) => {
    
    // Get logo dimensions based on size
    const getLogoDimensions = () => {
        return size === 'L' ? { height: '40px', width: 'auto' } : { height: '24px', width: 'auto' };
    };

    // Get text styling based on size
    const getTextStyling = () => {
        return size === 'L' 
            ? { fontSize: '16px', fontWeight: 'bold' }
            : { fontSize: '12px', fontWeight: 'bold' };
    };

    // Render logo image
    const renderLogoImage = () => {
        const dimensions = getLogoDimensions();
        const logoElement = (
            <ImageWithBasePath
                src={url}
                alt={name || 'Logo'}
                style={{
                    height: dimensions.height,
                    width: dimensions.width,
                    objectFit: 'contain'
                }}
            />
        );

        // For large size, show institute name next to logo if name is provided
        if (size === 'L' && name) {
            return (
                <>
                    {logoElement}
                    <div className="mx-3 d-none d-md-block" style={{ 
                        height: dimensions.height, 
                        width: '2px', 
                        background: 'rgba(32, 44, 75, 0.2)',
                        borderRadius: '1px'
                    }}></div>
                    <span 
                        className="fw-bold d-none d-md-block" 
                        style={{ 
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: "#202C4B",
                            letterSpacing: '0.5px',
                            textShadow: '0px 0px 1px rgba(32, 44, 75, 0.2)'
                        }}
                    >
                        {name}
                    </span>
                </>
            );
        }

        return logoElement;
    };

    // Render name text
    const renderNameText = () => {
        const textStyle = getTextStyling();
        return (
            <span 
                className="fw-bold p-2" 
                style={{ 
                    ...textStyle,
                    color: "#202C4B",
                    letterSpacing: '0.5px',
                    textShadow: '0px 0px 1px rgba(32, 44, 75, 0.2)'
                }}
            >
                {name}
            </span>
        );
    };

    // Render default branding (fallback)
    const renderDefaultBranding = () => {
        const textStyle = getTextStyling();
        const dividerHeight = size === 'L' ? '18px' : '12px';
        
        return (
            <div className="d-flex align-items-center mt-2">
                <span className="text-primary fw-bold" 
                    style={{ 
                        ...textStyle,
                        letterSpacing: '0.5px',
                        textShadow: '0px 0px 1px rgba(31, 136, 214, 0.2)'
                    }}
                >
                    {size === 'L' ? 'Pathshala' : 'P'}
                </span>
                <div className="mx-2" style={{ 
                    height: dividerHeight, 
                    width: '2px', 
                    background: 'rgba(32, 44, 75, 0.2)',
                    borderRadius: '1px'
                }}></div>
                <span className="fw-bold" 
                    style={{ 
                        ...textStyle,
                        color: "#202C4B",
                        letterSpacing: '0.5px',
                        textShadow: '0px 0px 1px rgba(32, 44, 75, 0.2)'
                    }}
                >
                    {size === 'L' ? 'Sanchalak' : 'S'}
                </span>
            </div>
        );
    };

    // Determine what to render
    const renderContent = () => {
        if (url) {
            return renderLogoImage();
        } else if (name) {
            return renderNameText();
        } else {
            return renderDefaultBranding();
        }
    };

    return (
        <div className="logo-text d-flex align-items-center">
            <div className="header-logo-container d-flex align-items-center">
                {renderContent()}
            </div>
        </div>
    )
}

export default HeaderLogo;